import {
  params, string, shape, customType, bool
} from '@thd-nucleus/data-sources';
import { BuyItAgainProductPod } from './BuyItAgainProductPod';

export const dataModel = {
  searchModel: params({
    navParam: string(),
    additionalSearchParams: customType('AdditionalParams').shape({
      svocID: string()
    }),
    storeId: string(),
    isBrandPricingPolicyCompliant: bool(),

  }).shape({
    buyitagain: params({ dataSource: string() })
      .arrayOf(shape((BuyItAgainProductPod.dataModel.product))).skip('skipBuyitagain', true)
  })
};
